<template>
  <div class="black-background">
    <navbar></navbar>
    <router-view class="margintop"></router-view>
    <footer2></footer2>
  </div>

</template>

<script>
import navbar from './components/navbar'
import footer2 from './components/footer2'
import home from './components/home'

export default {
  name: 'navbarid', // has to be unique
  components: {
    navbar,
    footer2,
    home
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Lato");
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');

body {
  font-family: 'Lato', sans-serif !important;
}
h1 {
  font-family: 'Poppins', sans-serif !important;
}
h2 {
  font-family: 'Lato', sans-serif !important;
}
h3 {
  font-family: 'Lato', sans-serif !important;
}
h4 {
  font-family: 'Lato', sans-serif !important;
}
h5 {
  font-family: 'Lato', sans-serif !important;
}
p{
  font-size: 20px !important;
}
.margintop{
margin-top: 60px
}
.black-background{
  background-color: #ffffff;
  color:#000000;
}
.p-color{
  color: #187BC2;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/App.vue